import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import JobStatusNotification from "../../../../../model/notification/job/JobStatusNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: JobStatusNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationJobStatusItem extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.routeToJob = this.routeToJob.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});
		const currentStatusLabel = this.props.notification.getCurrentStatusLabel();
		const previousStatusLabel = this.props.notification.getPreviousStatusLabel();

		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src={`/assets/img/icons/${this.props.notification.getNotificationIcon()}`}/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Job {this.props.notification.data.referenceNumber} &middot; Status Changed<br/>
						{previousStatusLabel.isDefined && <div>
							<small>from:</small>
							{previousStatusLabel.get}
						</div>}
						{currentStatusLabel.isDefined && <div>
							<small>to:</small>
							{currentStatusLabel.get}
						</div>}
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayCreatorName()}<br/>
						{this.props.notification.displayDate()}
					</div>
					<span className="notification-link" onClick={this.routeToJob}>View</span>
					<span className="notification-link-separator">|</span>
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to Proper job.
	 */
	routeToJob() {
		this.props.history.push(Routes.EditJob(this.props.notification.data.referenceNumber));
	}
}

export default withRouter<IComponentProps>(NotificationJobStatusItem);